import { gql } from "@apollo/client"
import { useQuery } from "@oysterhr/core"
import { Company } from "@oysterhr/schema"

export const EQUITY_CARTA_INTEGRATION = gql`
  query equityCartaIntegration($companyId: ID!) {
    company(companyId: $companyId) {
      id
      equityCartaIntegration {
        id
        authRequestUrl
        lastSyncedAt
      }
    }
  }
`

export default (companyId: string) =>
  useQuery<{ company: Company }>(EQUITY_CARTA_INTEGRATION, {
    variables: { companyId },
    fetchPolicy: "network-only",
  })
